// extracted by mini-css-extract-plugin
export var actions = "_3n-0";
export var actionsContainer = "_3n-6";
export var border = "_3n-1";
export var childFullHeight = "_3n-d";
export var collapse = "_3n-2";
export var content = "_3n-8";
export var contentChild = "_3n-c";
export var fullscreen = "_3n-a";
export var headerContainer = "_3n-3";
export var headerRow = "_3n-5";
export var hidePadding = "_3n-9";
export var noScrollX = "_3n-e";
export var noScrollY = "_3n-f";
export var optOutTopPadding = "_3n-b";
export var pagePadding = "_3n-7";
export var profile = "_3n-g";
export var profileContainer = "_3n-h";
export var profileImage = "_3n-i";
export var profileMain = "_3n-j";
export var profileSubtitle = "_3n-l";
export var profileTitle = "_3n-k";
export var tabsWrapper = "_3n-4";
export var title = "_3n-m";